import { ApplicationStage } from '../../../api/types';
import ListPageInner from '../../shared/ApplicationListPage/ListPageInner';

const InsuranceListPage = () => {
    const stage = ApplicationStage.Insurance;
    const namespace = 'insuranceList';

    return <ListPageInner namespace={namespace} stage={stage} />;
};

export default InsuranceListPage;
